import { Component, Injectable, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { el } from 'date-fns/locale';
import { ComponentsService } from 'src/app/components.service';

@Component({
    selector: 'app-pay-table-info',
    templateUrl: './pay-table-info.component.html',
    styleUrls: ['./pay-table-info.component.scss']
})
@Injectable({
    providedIn: 'root'
})
export class PayTableInfoComponent implements OnInit {
    reelPosition: any;
    gameType: string;

    constructor(
        private activeRoute: ActivatedRoute,
        private service: ComponentsService
    ) {}
    perms;
    clientId: any;
    gameCode: string = '';
    // tableData: any[] = [];
    reelPositionsImagePath: any;
    GotnSimbolImg: any;
    GotnPaylinesImg: any;
    statistic: any;

    countReelPosition: number;

    tableColumns: string[] = [
        'Theme/Paytable ID',
        'Theo. RTP',
        'ACT. RTP',
        'Game status',
        'Start Date/Time',
        'Number of games played',
        'Payin',
        'Payout',
        'Revenue',
        'Date/Time decommissioned'
    ];

    ngOnInit(): void {
        this.perms = this.service.getUsersPerm();
        this.clientId = this.service.getClientUuid();

        this.activeRoute.url.subscribe((url) => {
            this.gameCode = url[1].path;
            this.gameType = 'slot';
            this.setImgShowGOTN();
            this.service
                .getSlotStatistics(this.clientId, this.gameType, this.gameCode)
                .subscribe((data) => {
                    this.statistic = data.data;
                });
        });
    }

    setImgShowGOTN() {
        // let countReelPosition;
        let countSimbol;
        let countPaylines;

        switch (this.gameCode) {
            case 'GOTN':
                this.countReelPosition = 1;
                countSimbol = 6;
                countPaylines = 6;
                break;
            case '888':
                this.countReelPosition = 5;
                countSimbol = 7;
                countPaylines = 7;
                break;
            case '5FS':
                this.countReelPosition = 5;
                countSimbol = 8;
                countPaylines = 8;
                break;
            case '20FS':
                this.countReelPosition = 20;
                countSimbol = 8;
                countPaylines = 8;
                break;
            case '5GLX':
                this.countReelPosition = 5;
                countSimbol = 8;
                countPaylines = 8;
                break;

            case '27GLX':
                this.countReelPosition = 27;
                countSimbol = 9;
                countPaylines = 9;
                break;
            case 'CLGLX':
                this.countReelPosition = 5;
                countSimbol = 9;
                countPaylines = 9;
                break;
            case '20GLX':
                this.countReelPosition = 20;
                countSimbol = 8;
                countPaylines = 8;
                break;

            case '40GLX':
                this.countReelPosition = 40;
                countSimbol = 8;
                countPaylines = 8;
                break;
            case '20FX':
                this.countReelPosition = 20;
                countSimbol = 8;
                countPaylines = 8;
                break;
            case '10FX':
                this.countReelPosition = 10;
                countSimbol = 8;
                countPaylines = 8;
                break;
            case '40FX':
                this.countReelPosition = 40;
                countSimbol = 8;
                countPaylines = 8;
                break;
            case '5WX':
                this.countReelPosition = 5;
                countSimbol = 8;
                countPaylines = 8;
                break;
            case '20WX':
                this.countReelPosition = 20;
                countSimbol = 8;
                countPaylines = 8;
                break;
            case '40WX':
                this.countReelPosition = 40;
                countSimbol = 8;
                countPaylines = 8;
                break;
            case '40GDX':
                this.countReelPosition = 40;
                countSimbol = 11;
                countPaylines = 11;
                break;
            case '20GDX':
                this.countReelPosition = 20;
                countSimbol = 11;
                countPaylines = 11;
                break;

            case '5GDX':
                this.countReelPosition = 5;
                countSimbol = 11;
                countPaylines = 11;
                break;
            case '10RXT':
                this.countReelPosition = 10;
                countSimbol = 11;
                countPaylines = 11;
                break;
            case '40RXT':
                this.countReelPosition = 40;
                countSimbol = 11;
                countPaylines = 11;
                break;
            case '888GT':
                this.countReelPosition = 5;
                countSimbol = 9;
                countPaylines = 9;
                break;
            case '100FX':
                this.countReelPosition = 100;
                countSimbol = 8;
                countPaylines = 8;
                break;
            case '100RXT':
                this.countReelPosition = 100;
                countSimbol = 11;
                countPaylines = 11;
                break;
            case '40RXTCE':
                this.countReelPosition = 40;
                countSimbol = 11;
                countPaylines = 11;
                break;
        }
        this.reelPosition = [];

        for (let i = 1; i <= this.countReelPosition; i++) {
            this.reelPosition.push({
                path: `/backoffice/assets/slotovi-${this.gameCode}/${this.gameCode}_reel_positions${i}.png`
            });
        }

        this.GotnSimbolImg = [];
        for (let i = 1; i <= countSimbol; i++) {
            this.GotnSimbolImg.push({
                path: `/backoffice/assets/slotovi-${this.gameCode}/${this.gameCode}-simboli/${i}.png`,
                text: `${i}`
            });
        }

        this.GotnPaylinesImg = [];
        for (let i = 1; i <= countPaylines; i++) {
            this.GotnPaylinesImg.push({
                path: `/backoffice/assets/slotovi-${this.gameCode}/${this.gameCode}-paylines/${i}.png`,
                text: `x${i}`
            });
        }
    }
    onClick() {
        this.service
            .getSlotStatistics(this.clientId, this.gameType, this.gameCode)
            .subscribe((data) => {
                this.statistic = data.data;
            });
    }
}
